"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegPepp = void 0;
const base_1 = require("./base");
const pepp_1 = require("../services/pepp");
/**
 * Pepperjam Pixel
 */
class AnIntegPepp extends base_1.AnIntegBase {
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        pepp_1.AnServPepp.sendCustEvent(this.getPixelId(siteCategory), "", {
            INT: "DYNAMIC",
            ITEM_ID1: "subscription",
            ITEM_PRICE1: price.toString(),
            QUANTITY1: "1",
            NEW_TO_FILE: "1",
            COUPON: coupon,
            ORDER_ID: userId.toString(),
        });
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        return this.sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon);
    }
    static sendTrackEcommThankyou(siteCategory, userId, orderId, price, coupon) {
        pepp_1.AnServPepp.sendCustEvent(this.getPixelId(siteCategory), "", {
            INT: "DYNAMIC",
            ORDER_ID: orderId.toString(),
            NEW_TO_FILE: "0",
        });
        return true;
    }
}
exports.AnIntegPepp = AnIntegPepp;
AnIntegPepp.shouldSendTrackClubThankyou = true;
AnIntegPepp.shouldSendTrackClubThankyouLegacy = true;
AnIntegPepp.shouldSendTrackEcommThankyou = true;
AnIntegPepp.pixelId = {
    prod: {
        defaultId: "8680",
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: "8680",
        ecomm: null,
        club: null,
    },
};
